import { Form } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Editor from 'src/app/components/Editor'

type Prop = {
    setFooterContent: any
    footerContent: any
    setLain: any
    lain: any
    setBodyContent: any
    bodyContent: any
    canUpdate: any
}

const ApprovalSIPDetailLetterContent: React.FC<Prop> = ({
    setFooterContent,
    footerContent,
    setLain,
    lain,
    setBodyContent,
    bodyContent,
    canUpdate,
}) => {
    const { t } = useTranslation()
    return (
        <>
            <Form.Group className='mb-10' controlId='formBasicPassword'>
            <p className='fs-4 mt-2'>Body</p>
            <Editor
                disabled={!canUpdate}
                  data={bodyContent}
                  onChange={ ( content ) => {
                      setBodyContent(content)
                  }}
              />
          </Form.Group>

          <Form.Group className='mb-10' controlId='formBasicPassword'>
            <p className='fs-4 mt-2'>{t('Lain-lain')}</p>
            <Editor
            disabled={!canUpdate}
                  data={lain}
                  onChange={ ( content ) => {
                      setLain(content)
                  }}
              />
          </Form.Group>

          <Form.Group className='mb-10' controlId='formBasicPassword'>
            <p className='fs-4 mt-2'>Footer</p>
            <Editor
                disabled={!canUpdate}
                  data={footerContent}
                  onChange={ ( content ) => {
                      setFooterContent(content)
                  }}
              />
          </Form.Group>
        </>
    )
}

export default ApprovalSIPDetailLetterContent